import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddPlanzoneMaterialResourceNotificationState = createStateReducer(
  initialState,
  {
    [events.addPlanzoneMaterialResourceSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneMaterialResource",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addPlanzoneMaterialResourceFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneMaterialResource",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddPlanzoneMaterialResourceNotificationState };
